export default {
  name: "Preliminary Questions",
  symbol: "list",
  pageInfo: {
    text: "<strong>IMPORTANT</strong>: In accordance with 20 CFR 655.121, prior to filing an H-2A Application for Temporary Employment Certification (Form ETA-9142A), the employer must submit a job order (Form ETA-790/790A) to the State Workforce Agency (SWA) serving the area of intended employment, identifying it as a job order to be placed in connection with a future Form ETA-9142A for H-2A workers.  This Form ETA 790/790A is designed to (1) facilitate the initial receipt and processing of the job order by the SWA, (2) identify the employer(s) of the worker(s) sought for the job opportunity, (3) designate that the job order will be used in connection with a future Form ETA-9142A for H-2A workers, and (4) disclose all the material terms and conditions of employment that the employer will offer to H-2A workers and U.S. workers.",
    coloring: "grey",
  },
  sections: [
    {
      name: "Type of Clearance Order",
      fields: [
        {
          isGroup: {
            code: "1",
            label:
              "Indicate the type of agricultural clearance order being placed with the SWA for recruitment of U.S. workers (choose only one)*",
            machine_name: "eta_790_c1_clearance_order_type",

            tooltip: `If the clearance order is placed in connection with an H-2A Application for Temporary Employment Certification (Form ETA-9142A), please select the option entitled “<strong>790A (placed in connection with an H-2A application).</strong>” Prior to submitting the job order to the SWA, the employer will need to complete the remainder of the Form ETA-790A containing all material terms and conditions of employment and assurances for H-2A agricultural clearance orders.
            <br>
            <br>
            If the clearance order is not placed in connection with an H-2A application, select the option entitled “<strong>790B (not placed in connection with an H-2A application).</strong>” Prior to submitting the job order to the SWA, the employer will need to complete the Form ETA-790B containing all material terms and conditions of employment and assurances for agricultural clearance orders that are not placed in connection with H-2A applications.
            <br>
            <br>
            Only select one option.
            `,
            coloring: "none",
            disabled: true,
            fields: [
              {
                widget: "radio",
                // choice: "790A (H-2A clearance order)",
                choice: "790A (placed in connection with an H-2A application)",
                value: "790",
                checked: true,
                disabled: true,
              },
              {
                widget: "radio",
                // choice: "790B (regular clearance order)",
                choice:
                  "790B (not placed in connection with an H-2A application)",
                value: "790B",
                checked: false,
                disabled: true,
              },
            ],
          },
        },
      ],
    },
    {
      name: "Type of Employer Application",
      fields: [
        {
          isGroup: {
            code: "2",
            label:
              "Please select one of the options below to indicate the type of H-2A application that will be filed in connection with this job order.",
            machine_name: "prelim_2_employer_type",
            tooltip:
              "Select one of the following options to indicate the type of application being filed for temporary employment certification. Mark only one box. <ul><li>Individual Employer: Select this option if the application is being filed by or on behalf of one employer (non-association).<li>Joint Employer: Select this option if the application is being filed by or on behalf of two or more employers (non-association). Each employer seeking to jointly employ H-2A workers under this application must be identified on the Form ETA-790A, Addendum B, and separately submit a signed and dated Appendix A.</li><li>Association – Sole Employer: Select this option if the application is being filed by an agricultural association that will be the sole employer.</li><li>Association – Joint Employer: Select this option if the application is being filed by an agricultural association as a joint employer with each of the employer-members named on the application (i.e., a “master” application). Each employer-member seeking to jointly employ H-2A workers with the agricultural association under this application must be identified on the Form ETA-790A, Addendum B.</li><li>Association – Agent: Select this option if the application is being filed by an agricultural association acting as an agent (identified in Section D of the application) on behalf of employer-member(s).</li></ul><strong>Important Note:</strong> An agricultural association means any nonprofit or cooperative association of farmers, growers, or ranchers (including but not limited to processing establishments, canneries, gins, packing sheds, nurseries, or other similar fixed-site agricultural employers), incorporated or qualified under applicable State law, that recruits, solicits, hires, employs, furnishes, houses, or transports any worker that is subject to 8 U.S.C. 1188. 20 CFR 655.103. The association must retain documentation substantiating the employer or agency status of the association and be prepared to submit such documentation in response to a Notice of Deficiency (NOD) from the Certifying Officer (CO) prior to issuing a final labor certification decision, or in the event of an audit. 20 CFR 655.131(a).",
            coloring: "none",
            disabled: true,
            fields: [
              {
                widget: "radio",
                choice: "Individual Employer",
                value: "individual",
                validate: ["required"],
                conditionalClearTableErrors: {
                  table: "eta_790a_addendum_b_employment",
                  clearPageErrors: [10],
                  extraData: {
                    when: ["appIsItinerant", "prelim_5_is_livestock"],
                    is: ["!YES", "!YES"],
                    operator: "&&",
                  },
                },
              },
              {
                widget: "radio",
                choice:
                  "Joint Employer <i>(2 or more individual employers)</i>",
                value: "joint",
                validate: ["required"],
                conditionalClearTableErrors: {
                  table: "eta_790a_addendum_b_employment",
                  clearPageErrors: [10],
                  extraData: {
                    when: ["appIsItinerant", "prelim_5_is_livestock"],
                    is: ["!YES", "!YES"],
                    operator: "&&",
                  },
                },
              },
              {
                widget: "radio",
                choice: "Association - Sole Employer",
                value: "association-sole",
                validate: ["required"],
                conditionalClearTableErrors: {
                  table: "eta_790a_addendum_b_employment",
                  clearPageErrors: [10],
                  extraData: {
                    when: ["appIsItinerant", "prelim_5_is_livestock"],
                    is: ["!YES", "!YES"],
                    operator: "&&",
                  },
                },
              },
              {
                widget: "radio",
                choice: "Association - Joint Employer",
                value: "association-joint",
                validate: ["required"],
                conditionalSetTableErrors: {
                  table: "eta_790a_addendum_b_employment",
                  setPageErrors: [10],
                  checkTableFields: [
                    {
                      if: "begin_date",
                      is: null,
                    },
                  ],
                },
              },
              {
                widget: "radio",
                choice: "Association - Agent",
                value: "association-agent",
                validate: ["required"],
                conditionalClearTableErrors: {
                  table: "eta_790a_addendum_b_employment",
                  clearPageErrors: [10],
                  extraData: {
                    when: ["appIsItinerant", "prelim_5_is_livestock"],
                    is: ["!YES", "!YES"],
                    operator: "&&",
                  },
                },
              },
            ],
          },
        },
      ],
    },
    {
      name: "H-2A Labor Contractor",
      fields: [
        {
          isGroup: {
            code: "3",
            label:
              "Is the employer of the workers sought for the job operating as an H-2A Labor Contractor (H-2ALC), as defined by 20 CFR 655.103(b)?",
            machine_name: "prelim_3_is_contractor",
            tooltip:
              "Select “Yes” or “No” to indicate if the employer requesting certification is operating as an H-2A Labor Contractor (H-2ALC). Pursuant to 20 CFR 655.103(b), an H-2ALC is defined as any person who meets the definition of employer and is not a fixed-site employer, an agricultural association, or an employee of a fixed-site employer or agricultural association, as those terms are defined in 20 CFR 655.103(b), who recruits, solicits, hires, employs, furnishes, houses, or transports any worker subject to 8 U.S.C. 1188, 29 CFR part 501, or 20 CFR 655, subpart B.",
            coloring: "none",
            disabled: true,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
              },
            ],
          },
        },
      ],
    },
    {
      name: "Emergency Application",
      fields: [
        {
          isGroup: {
            code: "4",
            label:
              "Is this job order being filed in connection with a future request to waive the regulatory time period for submitting an H-2A application due to an emergency situation, as defined by 20 CFR 655.134? ",
            machine_name: "prelim_4_is_emergency",
            tooltip:
              "If the application is submitted less than 45 days before the employer’s date of need, select “Yes” or “No” to indicate whether the employer’s application is being filed with a request to waive the regulatory time period due to an emergency situation. Pursuant to 20 CFR 655.134(a), the CO may waive the time period for filing for employers who did not make use of temporary alien agricultural workers during the prior year's agricultural season or for any employer that has other good and substantial cause (which may include unforeseen changes in market conditions), provided that the CO has sufficient time to test the domestic labor market on an expedited basis to make the determinations required by 20 CFR 655.100. <br/><strong>Important Note:</strong> A request for waiver of the time period for filing requires the employer to concurrently submit to the Certifying Officer and the SWA serving the area of intended employment: a completed Form ETA-9142A; a completed job order, i.e., Form ETA-790A; and a statement justifying the request for waiver of the time period requirement. See 20 CFR 655.134.",
            coloring: "none",
            disabled: true,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
              },
            ],
          },
        },
      ],
    },
    {
      name: "Herding or Production of Livestock on the Range",
      fields: [
        {
          isGroup: {
            code: "5",
            label:
              "Is this job order being filed in connection with a future H-2A application seeking to employ temporary agricultural foreign workers to perform herding or production of livestock on the range, as defined by 20 CFR 655.201?",
            machine_name: "prelim_5_is_livestock",
            tooltip:
              "Select 'Yes' or 'No' to indicate whether the employer’s application is being filed in connection with a future H-2A application seeking to employ temporary agricultural foreign workers to perform herding or production of livestock on the range, as defined by 20 CFR 655.201.",
            coloring: "none",
            disabled: true,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
                conditionalSetTableErrors: {
                  table: "eta_790a_addendum_b_employment",
                  setPageErrors: [10],
                  checkTableFields: [
                    {
                      if: "begin_date",
                      is: null,
                    },
                  ],
                },
                removePagesErrors: [
                  {
                    if: "eta_790_a13_swa_state_id",
                    remove: 13,
                  },
                ],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
                setPagesErrors: [
                  {
                    if: "eta_790_a13_swa_state_id",
                    is: ["- Select -", undefined, null],
                    to: 13,
                  },
                ],
                conditionalClearTableErrors: {
                  table: "eta_790a_addendum_b_employment",
                  clearPageErrors: [10],
                  extraData: {
                    when: ["appIsItinerant", "prelim_2_employer_type"],
                    is: ["!YES", "!association-joint"],
                    operator: "&&",
                  },
                },
              },
            ],
          },
        },
      ],
    },
    {
      name: "Itinerant Work Involving Animal Shearing, Commercial Beekeeping, and Custom Combining",
      fields: [
        {
          isGroup: {
            code: "6",
            label:
              "Is this job order being filed in connection with a future H-2A application seeking to employ workers to perform animal shearing, commercial beekeeping, and custom combining work, as defined under § 655.301, on a scheduled itinerary covering multiple areas of intended employment?",
            machine_name: "appIsItinerant",
            tooltip:
              "Select 'Yes' or 'No' to indicate whether the employer’s application is being filed in connection with a future H-2A application seeking to employ temporary agricultural foreign workers to perform herding or production of livestock on the range, as defined by 20 CFR 655.201.",
            coloring: "none",
            disabled: true,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
                conditionalSetTableErrors: {
                  table: "eta_790a_addendum_b_employment",
                  setPageErrors: [10],
                  checkTableFields: [
                    {
                      if: "begin_date",
                      is: null,
                    },
                  ],
                },
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
                conditionalClearTableErrors: {
                  table: "eta_790a_addendum_b_employment",
                  clearPageErrors: [10],
                  extraData: {
                    when: ["prelim_5_is_livestock", "prelim_2_employer_type"],
                    is: ["!YES", "!association-joint"],
                    operator: "&&",
                  },
                },
              },
            ],
          },
        },
      ],
    },
  ],
};
